export default __webpack_public_path__ + "media/images/dashboard_icons/rsvp-groups-64668f292e6601aa292b15b20fb5bd45.svg";